export default __webpack_public_path__ + "static/media/oscer-pres-loss-hearing.6ae5cfd9.svg";